import * as Yup from 'yup';

export const rebateCompanyFormSchema = Yup.object().shape({
  utilRebateCompanyName: Yup.string().required('Rebate company name is required'),
  // municipalityCode: Yup.string().required('Municipality code is required'),
  rebateTypes: Yup.array().required('Rebate types is required'),
});
